module.exports = __webpack_public_path__ + "img/checkmark.5044338c.svg";